import { jsx as _jsx } from "react/jsx-runtime";
import { StoreHoursInfo, StoreHoursInfoDetails } from '../../common';
import { CLOSED, OPEN_24_HOURS } from '../constants';
import styles from '../DealerLocator.module.scss';
export const DealerLocatorStoreHoursInfo = ({ storeHoursOpen24HrsTitle, storeHoursTitle, store, isStoreLocationOptimizationFlag }) => {
    const { storeHours = [] } = store;
    const sortedStoreHours = [...storeHours].sort((a, b) => a.index - b.index);
    const storeHoursDetails = sortedStoreHours.map((element) => {
        return (_jsx(StoreHoursInfoDetails, { storeHoursInfoDetails: element }, element.label));
    }) || null;
    const isStoreClosed = storeHours.every((elem) => elem.value === CLOSED);
    const isStoreAvailable24Hrs = storeHours.every((elem) => elem.value === OPEN_24_HOURS);
    return (_jsx("div", { className: `d-flex flex-column order-lg-2 ${styles['resp-width']}`, children: _jsx(StoreHoursInfo, { title: storeHoursTitle, open24HoursTitle: storeHoursOpen24HrsTitle, isStoreAvailable24Hrs: isStoreAvailable24Hrs, isStoreClosed: isStoreClosed, isStoreLocationOptimizationFlag: isStoreLocationOptimizationFlag, children: _jsx("div", { className: 'mt-2', children: storeHoursDetails }) }) }));
};
